import {
  aggregateAncestorData,
  attrNameToDisplayName,
  EventAttributes,
} from '@cast/analytics';

import {
  getSysId,
  resolveDialogAttributes,
  resolveDrawerAttributes,
} from './_utils';

const resolveTableAttributes = (el: Element): EventAttributes => {
  const result: EventAttributes = {};
  const tableRoot = el.closest('.DS-Table-root');
  if (!tableRoot) {
    return result;
  }
  const recordsCount = tableRoot.querySelector('.RecordsCount-root');
  if (recordsCount) {
    result.tableRecords = recordsCount.textContent;
  }
  const cell = el.closest('.DS-Table-CellWrapper') as HTMLElement | undefined;
  if (cell) {
    result.tableColumnId = cell.getAttribute('data-column-id');
    if (cell.classList.contains('DS-Table-HeaderCellWrapper')) {
      result.headerText = cell.textContent;
    }
  }
  const tableSysId = getSysId(tableRoot);
  if (tableSysId) {
    result.tableSysId = tableSysId;
    result.tableSysName = attrNameToDisplayName(tableSysId);
  }

  return result;
};

const parentSysIds = (element: Element) => {
  const result = aggregateAncestorData({
    element,
    getter: (el) => getSysId(el),
  });
  if (result.length) {
    return result.reverse().join(' > ');
  }
  return undefined;
};

export const resolveContextualData = (el: Element): EventAttributes => {
  const result: EventAttributes = resolveTableAttributes(el);
  const drawerAttributes = resolveDrawerAttributes(el);
  result.parentSysIds = parentSysIds(el);
  if (drawerAttributes) {
    // If event happened in drawer - don't need to check dialog attributes
    return { ...result, ...drawerAttributes };
  }
  const dialogAttributes = resolveDialogAttributes(el);
  if (dialogAttributes) {
    return { ...result, ...dialogAttributes };
  }
  return result;
};
